module.exports = __webpack_public_path__ + "static/media/loading.11fd30d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/PlayGround/loading.svg
// module id = 1125
// module chunks = 0